import {WorkflowType} from "../enums/forms/workflowSteps/workflowType"
import assertNever from "../../global/assetNever"
import {PaymentGatewayType} from "~/enums/paymentGatewayType"
import {FormSectionValidationMode} from "~/enums/formSectionValidationMode"

export default class FormSubmissionStepDefinition {
  static getShowComponent(workflow_type: WorkflowType) {
    switch (workflow_type) {
      case WorkflowType.initialStep:
        return "show-data"
      case WorkflowType.approval:
        return "show-data"
      case WorkflowType.form:
        return "show-external-form"
      case WorkflowType.formSection:
        return "show-data"
      case WorkflowType.payment:
        return "show-payment"
      case WorkflowType.licenseStatusChange:
        throw new Error('Method not implemented')
      case WorkflowType.certificate:
        return "show-certificate"
      case WorkflowType.mapping:
        throw new Error('Method not implemented')
      case WorkflowType.processFlow:
        return "show-data"
      default:
        assertNever(workflow_type)
    }
  }

  static getEditComponent(workflow_type: WorkflowType) {
    switch (workflow_type) {
      case WorkflowType.initialStep:
        return "edit-data"
      case WorkflowType.approval:
        return "edit-data"
      case WorkflowType.form:
        return "edit-external-form"
      case WorkflowType.formSection:
        return "edit-data"
      case WorkflowType.payment:
        return "edit-payment"
      case WorkflowType.licenseStatusChange:
        throw new Error('Method not implemented')
      case WorkflowType.certificate:
        throw new Error('Method not implemented')
      case WorkflowType.mapping:
        throw new Error('Method not implemented')
      case WorkflowType.processFlow:
        throw new Error('Method not implemented')
      default:
        assertNever(workflow_type)
    }
  }

  static getEditPaymentComponent(paymentGatewayType: PaymentGatewayType) {
    switch (paymentGatewayType) {
      case PaymentGatewayType.payPal:
        return "edit-paypal"
      case PaymentGatewayType.payPalBrainTree:
        return "edit-paypal-braintree"
      case PaymentGatewayType.stripe:
        return "edit-stripe"
      case PaymentGatewayType.payPalPayflow:
        return "edit-paypal-payflow"
      case PaymentGatewayType.nic:
        return "edit-nic"
      case PaymentGatewayType.cyberSource:
        return "edit-cybersource"
      case PaymentGatewayType.velocity:
        return "edit-velocity"
      case PaymentGatewayType.bbt:
        return "edit-bbt"
      default:
        assertNever(paymentGatewayType)
    }
  }

  static getMockComponent(workflow_type: WorkflowType) {
    switch (workflow_type) {
      case WorkflowType.initialStep:
        return "mock-data"
      case WorkflowType.approval:
      case WorkflowType.form:
      case WorkflowType.formSection:
      case WorkflowType.payment:
      case WorkflowType.licenseStatusChange:
      case WorkflowType.certificate:
      case WorkflowType.mapping:
      case WorkflowType.processFlow:
        return "mock-empty"
      default:
        assertNever(workflow_type)
    }
  }

  static validationModeDisplay(validationWarning: FormSectionValidationMode): string {
    switch (validationWarning) {
      case FormSectionValidationMode.Submit:
        return 'Validate upon submission'
      case FormSectionValidationMode.Page:
        return 'Resolve all errors before next page'
    }
  }
}